var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1245 17.3022H20.8087M11.1245 21.5767H20.8087",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3412 3.34375L23.2295 11.6661",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4584 3.34375L7.51797 14.6976",
    stroke: "#201D1D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.526 14.318L30.4952 14.5641L30.4952 14.5641L29.526 14.318ZM26.6504 25.6408L27.6196 25.8869L27.6196 25.8869L26.6504 25.6408ZM5.34961 25.6408L6.31884 25.3946L6.31884 25.3946L5.34961 25.6408ZM2.47399 14.318L1.50476 14.5641L1.50476 14.5641L2.47399 14.318ZM13.3437 10.8257C12.7915 10.8257 12.3437 11.2734 12.3437 11.8257C12.3437 12.378 12.7915 12.8257 13.3437 12.8257V10.8257ZM28.5568 14.0718L25.6811 25.3946L27.6196 25.8869L30.4952 14.5641L28.5568 14.0718ZM22.7734 27.6562H9.22654V29.6562H22.7734V27.6562ZM6.31884 25.3946L3.44322 14.0718L1.50476 14.5641L4.38038 25.8869L6.31884 25.3946ZM4.41245 12.8257H8.84374V10.8257H4.41245V12.8257ZM9.22654 27.6562C7.85411 27.6562 6.65667 26.7248 6.31884 25.3946L4.38038 25.8869C4.94343 28.1039 6.93916 29.6562 9.22654 29.6562V27.6562ZM25.6811 25.3946C25.3433 26.7248 24.1459 27.6562 22.7734 27.6562V29.6562C25.0608 29.6562 27.0565 28.1039 27.6196 25.8869L25.6811 25.3946ZM30.4952 14.5641C30.9768 12.668 29.5439 10.8257 27.5875 10.8257V12.8257C28.2396 12.8257 28.7173 13.4398 28.5568 14.0718L30.4952 14.5641ZM3.44322 14.0718C3.2827 13.4398 3.76034 12.8257 4.41245 12.8257V10.8257C2.45611 10.8257 1.0232 12.668 1.50476 14.5641L3.44322 14.0718ZM13.3437 12.8257H27.5875V10.8257H13.3437V12.8257Z",
    fill: "#201D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketIcon);
export default __webpack_public_path__ + "static/media/BasketIcon.fd299bfe1116aa65e46db604b93f18ba.svg";
export { ForwardRef as ReactComponent };